import { render, staticRenderFns } from "./ReuploadDocument.vue?vue&type=template&id=3b0a089c&scoped=true"
import script from "./ReuploadDocument.vue?vue&type=script&lang=js"
export * from "./ReuploadDocument.vue?vue&type=script&lang=js"
import style0 from "./ReuploadDocument.vue?vue&type=style&index=0&id=3b0a089c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a089c",
  null
  
)

export default component.exports